import Request from '../Request';
import EndPoints, { applyPathVariables } from '../EndPoints';
import Methods from '../Methods';
/**
 * Update device settings using V2 API
 * @param Object object
 * @param organisationId String
 * @param deviceId String
 * @param blockUI boolean
 * @return {Promise<any>|Promise}
 */
export default (function (object, organisationKey, deviceId, blockUI) {
    if (blockUI === void 0) { blockUI = true; }
    var url = applyPathVariables(EndPoints.ORGANISATION_DEVICE_SETTINGS_V2, {
        organisationId: organisationKey,
        device: deviceId
    });
    var request = new Request({
        method: Methods.PUT,
        url: url,
        data: object,
        withCredentials: true,
        blockUI: blockUI
    });
    return request.execute();
});
